import { render, staticRenderFns } from "./_ChannelGroups.vue?vue&type=template&id=f325b15a&"
import script from "./_ChannelGroups.vue?vue&type=script&lang=ts&"
export * from "./_ChannelGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports